import React from "react";
import { Link } from "react-router-dom";
import { ArrowDownRight, ArrowRight } from "lucide-react";
import { useLang } from "../../contexts/LanguageContext";
import { t, tr } from "../../i18n/translations";

export default function Hero({ onBook }) {
  const { lang } = useLang();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen bg-[#FAFAFA] pt-28 pb-16" data-testid="hero-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end min-h-[80vh]">
          {/* Left text */}
          <div className="lg:col-span-7 flex flex-col justify-between">
            <p className="overline text-[#8B6D5E]" data-testid="hero-overline">{tr(t.hero.overline, lang)}</p>

            <div className="mt-12 lg:mt-0">
              <p className="mb-6 font-serif italic text-lg sm:text-xl text-[#8B6D5E] max-w-md" data-testid="hero-kicker">
                {tr(t.hero.kicker, lang)}
              </p>
              <h1
                className="font-serif font-light text-[14vw] sm:text-[12vw] lg:text-[9.5vw] xl:text-[8.5vw] leading-[0.88] tracking-tighter text-[#1A1A1A]"
                data-testid="hero-title"
              >
                Abril
                <br />
                <span className="italic text-[#8B6D5E]">Suarez</span>
              </h1>
              <p className="mt-8 max-w-xl font-serif text-2xl sm:text-3xl leading-tight text-[#1A1A1A]">
                {tr(t.hero.title, lang)}
              </p>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#5C5C5C]">{tr(t.hero.sub, lang)}</p>

              <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
                <button className="btn-primary" onClick={onBook} data-testid="hero-book-btn">
                  {tr(t.hero.cta_book, lang)} <ArrowRight size={14} />
                </button>
                <button className="btn-outline" onClick={() => scrollTo("portfolio")} data-testid="hero-portfolio-btn">
                  {tr(t.hero.cta_view, lang)}
                </button>
                <Link to="/quiz" className="overline text-[#8B6D5E] flex items-center gap-2 link-underline" data-testid="hero-quiz-link">
                  Hacer quiz gratuito →
                </Link>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="lg:col-span-5">
            <div className="zoom-frame aspect-[3/4] w-full">
              <img
                src="https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg"
                alt="Abril Suarez maquillaje editorial Aguascalientes"
                loading="eager"
              />
            </div>
            <div className="mt-6 flex items-center justify-between">
              <p className="overline text-[#5C5C5C]">Aguascalientes · MX</p>
              <button onClick={() => scrollTo("services")} className="overline text-[#1A1A1A] flex items-center gap-2 link-underline">
                Scroll <ArrowDownRight size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-24 border-t border-b border-[#E8E1DA] py-6 overflow-hidden bg-[#F4F0EC]">
        <div className="marquee-track text-[#1A1A1A]">
          {Array(2)
            .fill(null)
            .map((_, i) => (
              <div key={i} className="inline-flex items-center gap-16">
                <span className="font-serif italic text-3xl">Editorial</span>
                <span className="text-[#8B6D5E]">✦</span>
                <span className="font-serif italic text-3xl">Novias</span>
                <span className="text-[#8B6D5E]">✦</span>
                <span className="font-serif italic text-3xl">Eventos de Belleza</span>
                <span className="text-[#8B6D5E]">✦</span>
                <span className="font-serif italic text-3xl">Cursos</span>
                <span className="text-[#8B6D5E]">✦</span>
                <span className="font-serif italic text-3xl">Aguascalientes</span>
                <span className="text-[#8B6D5E]">✦</span>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
